<template>
  <HomeSectionWrapper :title="$t('recently_added.recent_artist')">
    <div class="p-2.5 sm:mt-0 mt-5">
      <div class="sm:py-20 py-6 rounded-2xl sm:px-5 px-2.5" v-if="pending">
        <HomeArtistSkeleton />
      </div>
      <div v-else>
        <div
          v-if="artists.length"
          class="sm:py-10 py-6 rounded-2xl sm:px-5 px-2.5"
        >
          <BaseCarousel :items="artists" :visible-items="getSkeletonGridCount">
            <template #default="{ item }">
              <div
                @click="goToProfile(item._id)"
                class="shrink-0 flex flex-col items-center w-24 text-center group cursor-pointer"
              >
                <div
                  class="relative sm:size-24 sm:min-w-24 size-18 min-w-18 mb-2"
                >
                  <BaseImage
                    @contextmenu.prevent
                    @dragstart.prevent
                    v-if="item.avatar"
                    :uri="item.avatar"
                    alt="Artist Avatar"
                    img-class="sm:size-24 sm:min-w-24 size-18 min-w-18 rounded-full object-cover border border-gray-100 group-hover:border-primary-blue transition-colors"
                  />
                  <div
                    class="sm:size-24 sm:min-w-24 size-18 min-w-18 rounded-full bg-primary-blue text-white flex items-center justify-center"
                    v-else
                  >
                    <p class="text-xl uppercase">
                      {{ item.name.slice(0, 1) }}
                      {{ item.last_name ? item.last_name.slice(0, 1) : "" }}
                    </p>
                  </div>
                  <div
                    class="absolute bottom-0 right-1 w-3 h-3 bg-green-500 border-2 border-white rounded-full"
                  ></div>
                </div>

                <span class="text-xs font-bold text-gray-800 truncate w-full">
                  {{ item.name }} {{ item.last_name }}
                </span>
                <span
                  v-if="item?.professions[0]?.label"
                  class="text-[10px] text-gray-400 truncate w-full uppercase mt-0.5"
                >
                  {{
                    item.professions[0].key === "other"
                      ? "Artist"
                      : item.professions[0].label[locale as Locale]
                  }}
                </span>
                <span
                  class="text-[10px] text-gray-400 truncate w-full uppercase mt-0.5"
                  v-else
                  >Artist</span
                >
              </div>
            </template>
          </BaseCarousel>
        </div>
        <div v-else></div>
      </div>
    </div>
  </HomeSectionWrapper>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";
import { useI18n } from "vue-i18n";
import type { FeaturedArtist } from "../../../types/featured.ts";
import type { Locale } from "~~/types/global.js";

const { width } = useWindowSize();
const { locale } = useI18n();
const localePath = useLocalePath();

const getSkeletonGridCount = computed<number>(() => {
  if (width.value > 1280) {
    return 10;
  } else if (width.value > 1024) {
    return 8;
  } else if (width.value > 786) {
    return 5;
  } else {
    return 3;
  }
});

const goToProfile = async (id: string) => {
  await navigateTo(localePath(`/artist/${id}`));
};

const { data, pending, status } = await useFetch<any>(`/api/artist/featured`, {
  query: {
    limit: 10,
    type: "contemporary",
  },
  server: true,
});

const artists = computed<FeaturedArtist[]>(() => data.value?.data || []);
</script>
